import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';
import { PagamentoContasPagarRequest } from '../../requests/financas/pagamento-contas-pagar.request';
import { PrepararPagamentoContasPagarRequest } from '../../requests/financas/preparar-pagamento-contas-pagar.request';
import { PrepararPagamentoContasPagarResponse } from '../../responses/financas/preparar-pagamento-contas-pagar.response';

@Injectable({
    providedIn: 'root'
})
export class PagamentoContasPagarParcelaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiFinancas + 'PagamentoContasPagarParcela';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public post(request: PagamentoContasPagarRequest): Observable<ReturnStruct> {
        return this.httpClient
            .post<ReturnStruct>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public preparar(request: PrepararPagamentoContasPagarRequest): Observable<PrepararPagamentoContasPagarResponse> {
        return this.httpClient
            .post<PrepararPagamentoContasPagarResponse>(`${this.apiUrl}/preparar`, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
